/**
 * Support/Feedback service layer.
 *
 * Sends support form submissions to the backend API endpoint.
 * Uses the existing apiClient (axios) which automatically attaches
 * auth tokens when the user is authenticated.
 */

import apiClient from '../utils/axios-config';
import { SupportSubmitPayload, SupportSubmitResponse } from '../utils/supportUtils';

/**
 * Submit a support/feedback form to the backend.
 * The backend will email the submission to the internal support address.
 */
export async function submitSupportForm(
  payload: SupportSubmitPayload
): Promise<SupportSubmitResponse> {
  try {
    const response = await apiClient.post<SupportSubmitResponse>(
      '/support/submit',
      payload
    );
    return response.data;
  } catch (error: any) {
    // Surface the backend error response if available
    if (error.response?.data) {
      return error.response.data as SupportSubmitResponse;
    }
    // Network or unexpected error
    return {
      success: false,
      error: {
        code: 'NETWORK_ERROR',
        message: 'Something went wrong. Please try again.',
      },
    };
  }
}
